/**
 * Storage utility functions
 * 
 * Authentication data is stored in sessionStorage (clears on tab close).
 * We rely on Auth0 SDK for Auth0 state and backend auto-resolve for session.
 * Only non-sensitive user info is stored for performance (prevents API calls on reload).
 * User acknowledgement is now managed by the backend API (/auth/whoami and /auth/acknowledge_terms).
 */

const AUTH_STORAGE_KEY = 'comphub_auth';

export const storage = {
  /**
   * Save authentication data (user info only, no sensitive data)
   * Uses sessionStorage - clears when tab closes
   */
  saveAuth: (authData) => {
    try {
      sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
    } catch (error) {
      // Silently handle storage errors
    }
  },

  /**
   * Get authentication data
   */
  getAuth: () => {
    try {
      const data = sessionStorage.getItem(AUTH_STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      return null;
    }
  },

  /**
   * Remove authentication data
   */
  removeAuth: () => {
    try {
      sessionStorage.removeItem(AUTH_STORAGE_KEY);
    } catch (error) {
      // Silently handle storage errors
    }
  },
};

